import script from "./Menus.vue?vue&type=script&lang=ts&setup=true"
export * from "./Menus.vue?vue&type=script&lang=ts&setup=true"

import "./Menus.vue?vue&type=style&index=0&id=2ab325ea&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ab325ea"]])

export default __exports__